<div class="search-container" [ngClass]="{ selected: isSearchBarSelected }">
  <input
    class="search-bar w-100"
    type="text"
    [(ngModel)]="searchTerm"
    (keyup)="searchExperiments()"
    (focus)="showSuggestions = true"
    placeholder="{{ 'pages.CATEGORIES.PLACEHOLDER' | transloco }}"
  />
  <i class="fas fa-search"></i>
  <!--Listado de sugerencias-->
  @if (showSuggestions) {
    <div class="search-suggestions-container w-100">
      @if (this.searchTerm.length >= 3) {
        <ul class="w-100">
          @for (experiment of filteredExperiments; track experiment) {
            <li
              class="search-suggestion-item w-100"
              (click)="
                selectSuggestion(experiment.title); showSuggestions = false
              "
            >
              {{ experiment.title }}
            </li>
          }
        </ul>
      }
      @if (this.searchTerm.length >= 3 && filteredExperiments.length === 0) {
        <div class="search-no-match">
          <p>{{ 'pages.CATEGORIES.NO-EXPERIMENTS' | transloco }}</p>
        </div>
      }
    </div>
  }
</div>
